import algoliasearch from 'algoliasearch/lite';

export const searchClient =
    process.env.NEXT_PUBLIC_ALGOLIA_APP_ID &&
    process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY &&
    algoliasearch(
        process.env.NEXT_PUBLIC_ALGOLIA_APP_ID,
        process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY
    );

export const getIndexesName = () => {
    return {
        stories: `${process.env.NEXT_PUBLIC_ALGOLIA_PREFIX}_stories`,
        textAnswers: `${process.env.NEXT_PUBLIC_ALGOLIA_PREFIX}_text-answers`,
    };
};
